import React, { useEffect } from "react";
import "./ThePlus.css";
import Whatsapp from "../Components/Whatsapp";
import FaqWidget from "./FaqWidget";
import Navbar from "../Components/Navbar";
import MainImg from "../Images/The Plus/the_plus_banner.webp";
import { Helmet } from "react-helmet";
import RedLightTherapy from "../Images/The Plus/Red Light Therapy.webp";
import RedHotPilates from "../Images/The Plus/Red Hot Pilates.webp";
import RedHotYoga from "../Images/The Plus/redhotyoga.webp";
import AromaThai from "../Images/The Plus/AromathaiMassage.jpeg";
import PrePostNatal1 from "../Images/The Plus/side-view-young-pregnant-woman-exercising-fitness-ball.webp";
import EventsImg from "../Images/The Plus/Events.webp";
import Headroom from "react-headroom";

const ThePlus = () => {
  useEffect(() => {
    document.title = "Corefit Plus Pilates Studio | Pilates Class Types";
  }, []);

  // Open Google Form in new tab
  const openForm = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSdCTwFhwgA086ImaX2CYjvzwdNWsuC20AS2OLhIAk0PSoyKOg/viewform?usp=sf_link",
      "_blank",
    );
  };

  return (
    <>
      <Helmet>
        <title>The Plus | Corefit Plus Pilates Studio</title>
        <meta
          name="description"
          content="See the Perfect Pilates Exercise for Your Fitness Goals at CorefitPlus. Find the Perfect Class to Enhance Your Strength, Flexibility, and Well-Being."
        />
      </Helmet>

      <Whatsapp />
      <FaqWidget />

      <div className="Hero1">
        <img src={MainImg} alt="The Plus" className="hero-image" />
        <Headroom>
          <div className="sticky-navbar">
            <Navbar />
          </div>
        </Headroom>
      </div>

      <div className="overlayxy">
        <div className="contentt-container">
          <p>
            <span className="writte1">The Plus</span>
          </p>
        </div>
      </div>

      <section id="pilates">
        <div className="tp">
          <div className="tp1">
            {/* <div className="tp22">
              <p>The Plus</p>
              <hr className="mnbv" />
            </div> */}
            <div className="tp33">
              <p>
                Corefit Plus is more than a Pilates studio. The Plus is our
                approach to wellness that goes beyond movement, bringing
                together Pilates, recovery therapies, specialized care, and a
                sense of community under one roof.
              </p>
            </div>
          </div>

          {/* Red Light Therapy */}
          <div className="tp1">
            <div className="red-light-container">
              <div className="red-light-content">
                <div className="tp2">
                  <p>Red Light Therapy</p>
                  <hr />
                </div>
                <div className="tp3">
                  <p>
                    A calm, quiet way to support recovery from the inside out.
                    Red light therapy helps with muscle recovery, inflammation,
                    skin health, and overall energy, making it a perfect add-on
                    to your movement routine or rest days.
                    <br />
                    <br />
                    Available at our GK-2 location.
                  </p>
                </div>
              </div>
              <div className="tp-img">
                <img src={RedLightTherapy} alt="Red Light Therapy" />
              </div>
            </div>
          </div>

          {/* Red Hot Pilates */}
          <div className="tp1">
            <div className="red-light-container reverse">
              <div className="red-light-content">
                <div className="tp2">
                  <p>Red Hot Pilates Session</p>
                  <hr />
                </div>
                <div className="tp3">
                  <p>
                    Pilates under infrared heat to help the body warm up faster
                    and move with ease. The heat supports flexibility,
                    circulation, and endurance while keeping the focus on
                    control, strength, and alignment.
                    <br />
                    <br />
                    Available at GK-2, Noida & NFC.
                  </p>
                </div>
              </div>
              <div className="tp-img">
                <img src={RedHotPilates} alt="Red Hot Pilates" />
              </div>
            </div>
          </div>

          {/* Yoga Hot Flow */}
          <div className="tp1">
            <div className="red-light-container">
              <div className="red-light-content">
                <div className="tp2">
                  <p>Yoga Hot Flow</p>
                  <hr />
                </div>
                <div className="tp3">
                  <p>
                    A slow, grounding yoga class practiced under red light and
                    gentle heat. Designed to release built-up tension, calm the
                    nervous system, and help you move without rushing or
                    forcing.
                    <br />
                    <br />
                    Available at Noida.
                  </p>
                </div>
              </div>
              <div className="tp-img">
                <img src={RedHotYoga} alt="Yoga Hot Flow" />
              </div>
            </div>
          </div>

          {/* Pre &amp; Post Natal Care */}
          <div className="tp1">
            <div className="red-light-container reverse">
              <div className="red-light-content">
                <div className="tp2">
                  <p>Pre &amp; Post Natal Care</p>
                  <hr />
                </div>
                <div className="tp3">
                  <p>
                    Specialized Pilates and recovery support for pregnancy and
                    the months after. Classes and sessions are designed to
                    support strength, mobility, breath, and confidence through
                    each stage, with care taken at every step.
                    <br />
                    <br />
                    Available at all locations
                  </p>
                </div>
              </div>
              <div className="tp-img">
                <img src={PrePostNatal1} alt="Pre & Post Natal Care" />
              </div>
            </div>
          </div>

          {/* Aroma Thai Massage */}
          <div className="tp1">
            <div className="red-light-container">
              <div className="red-light-content">
                <div className="tp2">
                  <p>Aroma Thai Massage</p>
                  <hr />
                </div>
                <div className="tp3">
                  <p>
                    Traditional Thai techniques paired with aromatic oils to
                    ease deep muscle tension. Ideal for recovery, stress relief,
                    or simply giving your body a proper reset. <br />
                    <br />
                    Available at Noida & GK-2.
                  </p>
                </div>
              </div>
              <div className="tp-img">
                <img src={AromaThai} alt="Aroma Thai Massage" />
              </div>
            </div>
          </div>

          {/* Events */}
          <div className="tp1">
            <div className="red-light-container reverse">
              <div className="red-light-content">
                <div className="tp2">
                  <p>Events at Corefit Plus</p>
                  <hr />
                </div>
                <div className="tp3">
                  <p>
                    Because wellness is also about connection. From birthdays
                    and anniversaries to studio meet-ups, we create moments that
                    bring people together beyond the workout.
                    <br />
                    <br />
                    Available at all locations.
                  </p>
                </div>
              </div>
              <div className="tp-img">
                <img src={EventsImg} alt="Events" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GOOGLE FORM BUTTON */}
      <section id="benefits">
        <div className="cun2">
          <div className="tycc12">
            <h4>
              CONTACT FORM <hr className="cu9" />
            </h4>
            <button className="open-google-form" onClick={openForm}>
              Enquire Here
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ThePlus;
